<template>
	<div class="comp">
		<el-dialog :title="'商品套餐'" :visible.sync="dialogState" width="1200px" @close="submit('close')">
			<div class="label">套餐内包含以下商品：</div>
			<div v-if="groupInfo.basic_info">
				<div style="line-height: 40px;" v-for="(item,index) in groupInfo.basic_info.items" :key="index">
					{{index+1}}. 
					<span style="margin-left:5px;">{{item.goods_name}}</span> 
					<span style="padding:0 30px;">{{item.sku_value}}</span>
					{{item.count}}{{item.unit}}
				</div>
			</div>
			<el-input style="width:400px;padding-top:20px;" v-model="scanningCodeInput" @keyup.enter.native="clickScanningCodeInput">
				<template slot="prepend">录入条码</template>
			</el-input>
			<el-table :data="tableData" style="width: 100%;margin-bottom: 20px;margin-top: 30px;" row-key="tableKey"
			:tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}" default-expand-all>
				<el-table-column prop="goodsName" label="商品名称">
				</el-table-column>
				<el-table-column label="条码" width="250">
					<template slot-scope="scope">
						{{scope.row.goodsList?'':scope.row.customCode}}
					</template>
				</el-table-column>
				<el-table-column prop="skuValue" label="规格" width="250">
				</el-table-column>
				<el-table-column prop="unit" label="单位" width="100">
				</el-table-column>
				<el-table-column label="数量" width="100">
					<template slot-scope="scope">
						<span>{{scope.row.num}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button v-if="scope.row.index==undefined" @click="del(scope.row)" type="danger" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-row>
				<el-col :span="5" :offset="19">
					<el-button style="width:200px;margin-top:50px;" type="primary" @click="submit('submit')">已录入完成</el-button>
				</el-col>
			</el-row>
		</el-dialog>
	</div>
</template>
<script>
	import del from "../util/del.js"
	export default {
		data() {
			return {
				dialogState:true,
				scanningCodeInput:'',
				o:null,
				tableData:[]
			}
		},
		props:{
			groupInfo:{
				type:Object,
				default:()=>{
					return {}
				},
			},
			groupTable:{
				type:Array,
				default:()=>{
					return []
				},
			},
		},
		mounted() {
			this.init();
		},
		methods: {
			init(){
				if(this.groupTable.length===0){
					let table = this.groupInfo.basic_info.items;
					let table2 = [];
					for(let i=0;i<table.length;i++){
						let one = {
							customCode:'',
							"goodsId": table[i].goods_id,
							"goodsName": table[i].goods_name,
							"goodsType": 1,
							skus: table[i].skus||table[i].goods_id, // 规格 skus
							skuValue: table[i].sku_value||'', // 规格 skuValue
							"unit": table[i].unit,
							"originalPrice": table[i].price,
							"price": table[i].price,
							"num": table[i].count,
							"totalMoney": this.$public.cheng(table[i].price,table[i].count),
							"goodsUsage": table[i].goodsUsage||'',
							"goodsDosage": table[i].goodsDosage||'',
							"goodsList": [],
							"remark": table[i].remark||'',
							extendContent:table[i].extendContent?JSON.parse(table[i].extendContent):''
						}
						one.tableKey='tableKey_tao_one'+Math.random();
						one.checkGoods = JSON.parse(JSON.stringify(one));
						table2.push(one)
					}
					this.o = new del();
					this.o.init(table2);
					this.tableData = this.o.arr;
				}else{
					this.o = new del();
					this.o.init(this.groupTable);
					this.tableData = this.o.arr;
				}
			},
			clickScanningCodeInput(){
				this.getScanData(this.scanningCodeInput)
			},
			getScanData(code) {
				this.o.searchGoods(code,'isGoodsGroup').then(()=>{
					this.scanningCodeInput = '';
					let addState = this.o.addTwoGoods(['chongfu','xianliang']);
					if(addState.type==="success"){
						console.log('添加成功')
					}
					this.tableData = this.o.arr;
				})
			},
			submit(str){
				if(str==='close'){
					this.$emit('submit',{type:'close'})
				}else if(str=='submit'){
					this.$emit('submit',{type:'success',data:{groupInfo:this.groupInfo,table:this.tableData}})
				}
			},
			// 删除商品
			del(row){
				let posi = this.o.searchDel(row.customCode.trim());
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.o.delTwo(posi);
					this.tableData = this.o.arr;
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.label{
			padding:0px 0 10px;
		}
	}
</style>
